import { Component, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ANALYTICS } from 'src/app/common/core/common.constants';
import { PDLService } from 'src/app/services/pdl-service.service';
import { isNullOrUndefined } from 'src/app/services/utils';

@Component({
  selector: 'app-service-agreement',
  templateUrl: './service-agreement.component.html',
  styleUrls: ['./service-agreement.component.scss']
})
export class ServiceAgreementComponent implements OnInit {
  serviceTermsText: any;
  authoringContentData: any;
  isBusinessAdvisement:boolean;
  isEnrolledForPaperless:boolean;
  businessAdvisementText: any;
  isFromRatePlan:boolean;
  modalName: any;
  display = 'display';

  constructor(public utilsSvc: UtilsService, public manageLineService: ManageLineService, public activeModal: NgbActiveModal,private pdlService: PDLService) { }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();

    let modalInfo = {
      eventAction: ANALYTICS.LOAD,      
      modalName:this.authoringContentData.changeService.serviceAggrementText,       
    };
    if(this.isFromRatePlan){
      modalInfo['stage'] = this.authoringContentData.changeRatePlan.inProgress
      modalInfo['name'] = this.authoringContentData.changeRatePlan.changeRatePlanText
    }   
    this.pdlService.ifEnabledGenerateModalViewTag(modalInfo);
  }

  test() {
    return;
  }

  print(){
    window.print();
  }

  OnClose() {
    this.activeModal.close(); //It closes successfully 
  }

  closeButtonTagging(event:any){
    this.manageLineService.close();
    let buttonName:any;
    let assetType:any;
    if(!isNullOrUndefined(event) && event.currentTarget.innerText === this.authoringContentData.changeService.changeServiceText){
      buttonName = this.authoringContentData.changeService.changeServiceText;
      assetType= ANALYTICS.LINK;
    }else if(!isNullOrUndefined(event) && event.currentTarget.innerText === this.authoringContentData.changeService.ChangeRatePlanTxt){
      buttonName = this.authoringContentData.changeService.ChangeRatePlanTxt;
      assetType= ANALYTICS.LINK;
    }
    else if(!isNullOrUndefined(event) && event.currentTarget.innerText === this.authoringContentData.customizeAuthoring.cancelCta){
      buttonName = this.authoringContentData.customizeAuthoring.cancelCta;
      assetType= ANALYTICS.BUTTON;
    }
    else if(!isNullOrUndefined(event) && event.currentTarget.innerText === this.authoringContentData.changeService.removeServiceContinueBtn){
      buttonName = this.authoringContentData.changeService.removeServiceContinueBtn;
      assetType= ANALYTICS.BUTTON;
    }
    else{
      buttonName = ANALYTICS.CLOSE;
      assetType = ANALYTICS.BUTTON;
    }
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: buttonName,
      assetType: assetType,
      modalName:this.authoringContentData.changeService.serviceAggrementText
    });
  }
}
